import React from 'react';

import './Loading.css';

function Loading() {
  return (
    <div className="d-flex justify-content-center Loading-content">
      <img src="logo512.png" alt="loading logo" className="loading-logo" />
    </div>
  )
}

export default Loading;
